import { graphql } from '../../../gql';

// TRIL-350: the "My replies" page. Lists a user's own replies (server sources
// them from PostsTable.UsernameIndex filtered to POSTREPLY#). Reuses the
// canonical ReplyCardFields fragment (same shape getReplies/getThread return) +
// `score` (for the SQS link) + `bookmarkCount` (the fragment carries likeCount).
export const GET_USER_REPLIES_QUERY = graphql(`
  query getUserReplies($username: String!) {
    getUserReplies(username: $username) {
      ...ReplyCardFields
      score
      viewerInteractions {
        bookmarkCount
      }
    }
  }
`);
